export default {
    mailBox: [],
    currentMailBoxSelect: null,
    listMailReceive: [],
    listMailSendBulk: [],
    mailThreadView: null,
    indexGroupOpen: [],
    searchFilter: null,
    mode: false,
    selectedReceiveMail: {},
    listIncludeSubFolder: '[]',
    mailDetail: null,
}